import styled from "styled-components";

export const ContainerWrapper = styled.div<{
    $paddingMode?: "all" | "top";
    $withoutGap?:"false" | "true";
}>`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${({ $paddingMode }) =>
        $paddingMode === "top"
            ?
            ` padding-top: var(--spacing-sm); `
            : 
            ` padding: var(--spacing-sm); `
    }

    ${({ $withoutGap }) =>
        $withoutGap === "true"
            ?
            ` gap: 0px; `
            : 
            ` gap: var(--spacing-sm); `
    }
`;

export const SpinWrapper = styled.div`
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: var(--spacing-sm);    
`